#import "../fragments/drip-sequence-stub-fragment.graphql"

mutation CreateDripSequence($dripSequence: DripSequenceCreateInput!) {
    dripSequenceCreate(input: $dripSequence) {
        dripSequence {
            ...DripSequenceStubFragment
        }
    }
}
